var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.bannerPic ? 'bg_image' : 'bg_image_web']},[_c('img',{attrs:{"src":'../../static/images/logo_'+this.brandName+'.png'}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95567e50","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 503
// module chunks = 1